// extracted by mini-css-extract-plugin
module.exports = {"obtMultiLineTextField":"OBTMultiLineTextField_obtMultiLineTextField__14-zx","fixed":"OBTMultiLineTextField_fixed__2b54l"};